const scope = "openid offline_access customer_self_service";

export const authConfig = {
    prod: {
        clientId: process.env.CLIENT_SECRET_PROD,
        redirectUri: "https://cdn.trumpf.com/static/auth-callback.html",
        issuer: "https://identity.trumpf.com",
        scope
    },
    qa: {
        clientId: process.env.CLIENT_SECRET_QA,
        redirectUri: "https://cdn-q.trumpf.com/static/auth-callback.html",
        issuer: "https://identity-s.trumpf.com",
        scope
    }
};
